<template>
  <!-- Voir l'espace client tel que le client le voit : l'opérateur ZEborne seulement (ouvre un onglet, session qui meurt
       avec le navigateur). -->
  <v-btn v-if="allowed && customerId" small outlined color="primary" :loading="impersonating" @click="open">
    <v-icon small left>mdi-account-eye-outline</v-icon>{{ $t('customer.client-space-impersonate') }}
  </v-btn>
</template>

<script>
import CustomerRepository from '@repository/CustomerRepository'

/** « Se connecter en tant que » le client : sur sa fiche client comme sur sa fiche membre. */
export default {
  name: 'ClientSpaceImpersonateButton',

  props: {
    customerId: { type: String, default: null },
  },

  data() {
    return { impersonating: false }
  },

  computed: {
    allowed() {
      return !!this.currentUser?.isZE && (this.currentUser.permissions || []).includes('CLIENT_SPACE_IMPERSONATE')
    },
  },

  methods: {
    open() {
      // L'onglet s'ouvre tout de suite (dans le geste de l'utilisateur, sinon le navigateur le bloque) et reçoit
      // l'adresse quand le ticket arrive. Toujours le même onglet, nommé : ouvrir un autre client y remplace le
      // précédent au lieu d'empiler les onglets.
      const tab = window.open('about:blank', 'zeborne-client-space')
      this.impersonating = true
      CustomerRepository.startClientSpaceImpersonation(this.customerId).then(({ url }) => {
        if (tab) {
          tab.opener = null
          tab.location.href = url
        } else {
          window.location.href = url
        }
      }).catch(err => {
        if (tab) tab.close()
        this.notifyError(err)
      }).finally(() => {
        this.impersonating = false
      })
    },
  },
}
</script>
